import { Icon } from "./Icon.jsx";

const NAVIGATION_ITEMS = [
  { id: "pending-orders", label: "Pesanan", icon: "orders" },
  { id: "fleet-orders", label: "Fleet Order", icon: "truck" },
  { id: "do-preparations", label: "Pembuatan DO", icon: "document" },
  { id: "master-data", label: "Data Master", icon: "master" },
];

export function AppShell({ activePage, children, onNavigate }) {
  return (
    <div className="app-shell">
      <a className="skip-link" href="#app-content">
        Lewati ke konten utama
      </a>

      <header className="navbar">
        <div className="navbar__brand">
          <button aria-label="Aplikasi" className="app-switcher" type="button">
            <Icon name="apps" size={18} />
          </button>
          <a
            className="app-identity"
            href="/"
            onClick={(event) => {
              event.preventDefault();
              onNavigate("pending-orders");
            }}
          >
            <span className="app-logo" aria-hidden="true">
              <img
                src="/brand/route-planning-navbar-64.png"
                alt=""
              />
            </span>
            <strong>Route Planning</strong>
          </a>
        </div>

        <nav aria-label="Navigasi utama" className="main-nav">
          {NAVIGATION_ITEMS.map((item) => (
            <button
              aria-current={item.id === activePage ? "page" : undefined}
              className={item.id === activePage ? "is-active" : ""}
              key={item.id}
              onClick={() => onNavigate(item.id)}
              type="button"
            >
              {item.label}
            </button>
          ))}
        </nav>

        <div className="navbar__user">
          <span className="navbar__role">Operasional</span>
          <span className="avatar">OP</span>
        </div>
      </header>

      <div className="app-content" id="app-content" tabIndex="-1">
        {children}
      </div>

      <nav aria-label="Navigasi seluler" className="mobile-bottom-nav">
        {NAVIGATION_ITEMS.map((item) => (
          <button
            aria-current={item.id === activePage ? "page" : undefined}
            className={item.id === activePage ? "is-active" : ""}
            key={item.id}
            onClick={() => onNavigate(item.id)}
            type="button"
          >
            <Icon name={item.icon} size={19} />
            <span>{item.label}</span>
          </button>
        ))}
      </nav>
    </div>
  );
}
